import { useMemo } from 'react'
import { useRequest } from '@/hooks/useRequest'

interface LegacyCollection {
  id: number | string
  shard_count?: number
  [key: string]: any
}

const LEGACY_COLLECTIONS: LegacyCollection[] = []

export const useLegacyCollections = () => {
  const legacyCollectionsIDs = LEGACY_COLLECTIONS.map(collection => collection.id)

  const { data: counts } = useRequest({
    url: `/users/@me/collections?id__in=${legacyCollectionsIDs.join(',')}`,
  })

  return useMemo(() => {
    LEGACY_COLLECTIONS.forEach(legacyCollection => {
      for (let i = 0; i < (counts as any)?.results.length; i++) {
        const collection = (counts as any)?.results[i]

        if (collection.id === legacyCollection.id) {
          legacyCollection.shard_count = collection.shard_count
          break
        }
      }
    })

    return LEGACY_COLLECTIONS
  }, [
    counts
  ])
}
